import { assert } from 'assert-ts';

type WithIpAddresses = { ipAddresses: readonly string[] };

/** Returns the IPv4 overlay IP from a host, if one exists. */
export function getIpV4({ ipAddresses }: WithIpAddresses): string | undefined {
  assert(ipAddresses.length <= 2, `Host should have at most 2 ipAddresses (one per family), got ${ipAddresses.length}`);
  return ipAddresses.find((ip) => ip.includes('.'));
}

/** Returns the IPv6 overlay IP from a host, if one exists. */
export function getIpV6({ ipAddresses }: WithIpAddresses): string | undefined {
  assert(ipAddresses.length <= 2, `Host should have at most 2 ipAddresses (one per family), got ${ipAddresses.length}`);
  return ipAddresses.find((ip) => ip.includes(':'));
}

/** Returns ipAddresses sorted with IPv6 before IPv4, matching the networks list / host header convention. */
export function sortIpsV6First(ipAddresses: readonly string[]): string[] {
  return ipAddresses.toSorted((a, b) => Number(b.includes(':')) - Number(a.includes(':')));
}
